<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="
        M2.6665
        11.1666L2.6665
        11.8333C2.6665
        12.9379
        3.56193
        13.8333
        4.6665
        13.8333L11.3332
        13.8333C12.4377
        13.8333
        13.3332
        12.9379
        13.3332
        11.8333L13.3332
        11.1666M10.6665
        8.49998L7.99984
        11.1666M7.99984
        11.1666L5.33317
        8.49998M7.99984
        11.1666L7.99984
        3.16665
      "
      stroke="#6B7280"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

</template>

<script>
export default {
  name: 'Download',
};
</script>
